import React from 'react';
import {MasterLayout} from 'layout';
import { header } from 'constants/table';
import DataTable from 'components/data-table';
import {RowItemDanhSachBaoCaoBCTH} from './datatable';
import {ContainerFileDinhKem} from 'components/upload';
import {Link, browserHistory} from 'react-router';
import { Button } from '@blueprintjs/core';
import {ThongKeBaoCao} from 'api';
import { Toastr } from 'modules/toastr';
import moment from 'moment';
import { msg } from "constants/message";

class DanhSachBaoCaoBCTH extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: {
        listTaiLieuBaoCao: [],
        baoCaoTongHopInfo: {}
      },
      loaiBaoCao: [],
      tableLoading: false,
      dataFileDinhKem: [],
      dataFileDinhKemDelete: []
    }
  }

  componentDidMount() {
    if (this.props.params.id) {
      this.getInfo(this.props.params.id);
      this.getLoaiBaoCaoList(this.props.params.id);
    }
  }

  getInfo(idBC) {
    ThongKeBaoCao.actions.getBaoCaoTongHopChiTiet.request({id: idBC}).then(res => {
      if (res.data) {
        res.data.listTaiLieuBaoCao.map(item => {
          item.soQuyetDinh = item.soVanBan;
          item.ngayQuyetDinh = item.ngayRaVanBan;
          return item;
        })
        this.setState({
          data: res.data
        });
      }
    });
  }
  getLoaiBaoCaoList(idBC) {
    this.setState({tableLoading: true});
    ThongKeBaoCao.actions.getBaoCaoTongHopDSBaoCao.request({id: idBC}).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({
          loaiBaoCao: res.data._embedded.baoCaoTongHopChiTiets,
          tableLoading: false
        });
      }
    });
  }

  pushTaiLieuDinhKem() {
    let dataFileDinhKem = [...this.state.dataFileDinhKem];
    let taiLieuVanThuUpdate = [];
    let taiLieuVanThuPost = [];
    let taiLieuVanThuDelete = [];

    if (dataFileDinhKem.length > 0) {
      dataFileDinhKem.map((item, i) => {
        if (item.taiLieuVanThuId) {
          taiLieuVanThuUpdate = [...taiLieuVanThuUpdate, {
            baoCaoTongHop: {
              id: Number(this.props.params.id)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soVanBan: item.soQuyetDinh,
            ngayRaVanBan: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            urlFile: item.duongDan,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          }];
        } else {
          taiLieuVanThuPost = [...taiLieuVanThuPost, {
            baoCaoTongHop: {
              id: Number(this.props.params.id)
            },
            ten: item.ten,
            soVanBan: item.soQuyetDinh,
            ngayRaVanBan: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            urlFile: item.duongDan,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          }];
        }
      });
    }

    this.state.dataFileDinhKemDelete.forEach(item => {
      taiLieuVanThuDelete = [...taiLieuVanThuDelete, {
        id: item
      }];
    });

    this.postTaiLieuVanThu(taiLieuVanThuPost, () => {
      this.updateTaiLieuVanThu(taiLieuVanThuUpdate, () => {
        this.deleteTaiLieuVanThu(taiLieuVanThuDelete, () => {
          Toastr(msg.dkLuuHoSo, 'success');
          browserHistory.goBack();
        });
      });
    });
  }

  updateTaiLieuVanThu(files, callback) {
    if (files.length) {
      let params = {
        taiLieuBaoCaos: files
      };
      ThongKeBaoCao.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        callback();
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
      });
    } else {
      callback();
    }
  }

  postTaiLieuVanThu(files, callback) {
    if (files.length) {
      let params = {
        taiLieuBaoCaos: files
      };
      ThongKeBaoCao.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        callback();
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
      });
    } else {
      callback();
    }
  }

  deleteTaiLieuVanThu(files, callback) {
    if (files.length) {
      let params = {
        taiLieuBaoCaos: files
      };
      ThongKeBaoCao.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        callback();
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
      });
    } else {
      callback();
    }
  }

  onFileChange(data) {
    this.setState ({
      dataFileDinhKem: data
    });
  }

  onFileRemove(id, data) {
    this.state.dataFileDinhKemDelete = [
      ...this.state.dataFileDinhKemDelete,
      id
    ];
    this.state.dataFileDinhKem = data;
    this.forceUpdate();
  }

  handleSave() {
    this.pushTaiLieuDinhKem();

  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container wrap-block" ref='thongKeBaoCao'>
          <div className="back-foward mb0">
            <Link onClick={browserHistory.goBack}>Về trang trước</Link>
          </div>
          <div className="top-content">
            <div className="left-content">
                <p className="title-18"><i className="tt tt-thongke"></i>Tổng hợp {this.state.data.tenBaoCao} năm {this.state.data.namBaoCao}</p>
            </div>
          </div>
          <div className="bottom-content thongke-content">
            <div className='row pl10 pr10'>
              <h2 className='title-14 col-100 pt20 pl20 pr20'>1. Danh sách biểu mẫu</h2>
            </div>
            <div className="wrap-table clear-left">
              <DataTable
                header={header.baoCaoTongHopDSBC}
                dataList={this.state.loaiBaoCao}
                hidePagination
                parent={this}
                hideButtonExport
                tableLoading={this.state.tableLoading}
              >
                <RowItemDanhSachBaoCaoBCTH/>
              </DataTable>
            </div>
            <div className='row pl15 pr15 pb15'>
              <span className='big-border'></span>
            </div>
            <div className='row pl30 pr30 '>
              <ContainerFileDinhKem label="2. Danh sách văn bản xử lý" labelClass="title-14" disableTopLine={true} bindValidator={this} data={this.state.data.listTaiLieuBaoCao} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} allowExcelFile={true}/>
            </div>
          </div>
          <div className="pt30">
            <div className="box-bottom">
              <Button type="button" className="btn-action btn-close" onClick={browserHistory.goBack}><span>Đóng</span></Button>
              <Button type="button" className="btn-action btn-save btn-green" onClick={ this.handleSave.bind(this) }>Lưu</Button>
            </div>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

export default DanhSachBaoCaoBCTH;



// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/DanhSachBaoCaoBCTH.jsx